import {StyleSheet} from 'react-native';

export const styles = StyleSheet.create({
  container: {flex: 1},
  subContainer: {justifyContent: 'flex-end'},
  listContainer: {paddingTop: 10},
  countBox: {
    paddingHorizontal: 15,
    borderRadius: 50,
    paddingVertical: 2.5,
    marginRight: 10,
  },
  dividerStyle: {marginVertical: 20},
  dropText: {
    textAlign: 'left',
    maxWidth: '85%',
  },
});
